import { axiosGateway } from "@/services/axiosTools";
import { authorizeApply } from "@/api/ai";
import store from "@/store";
import { sleep } from "@/utils";
const SLBROWSER_PC_AI_ASSIST_AUTHORIZATION =
  "slbrowser_pc_ai_assist_authorization";

export function retryPromise(asyncFn, params, times) {
  if (!navigator.onLine) {
    store.commit("setInterfaceError", true);
    return Promise.reject("网络错误");
  }
  return asyncFn(params)
    .then(async (res) => {
      const { code, data } = res;
      if (
        code !== 10000 ||
        !data ||
        (data && !data.list && data.length === 0) ||
        (data.list && !data.list.length === 0)
      ) {
        if (times > 0) {
          await sleep(1000);
          return retryPromise(asyncFn, params, times - 1);
        } else {
          store.commit("setInterfaceError", true);
          return Promise.reject(res);
        }
      }
      return Promise.resolve(res);
    })
    .catch(async (err) => {
      console.log(err, "err");
      if (times > 0) {
        await sleep(1000);
        return retryPromise(asyncFn, params, times - 1);
      } else {
        store.commit("setInterfaceError", true);
        return Promise.reject(err);
      }
    });
}

// 获取模型列表
export function getModelList(data) {
  const { product } = data;
  function asyncFn(product) {
    return axiosGateway.get({
      url: `/cloud-browser-aigc/rest/clientmodel/v2/${product}/release`,
      gatewayKey: "baseURL2",
    });

    //  ! 模拟接口返回
    // return new Promise((resolve, reject) => {
    //     resolve({
    //         code: 10000,
    //         message: 'Success',
    //         data: {
    //             version: 1747720007000,
    //             list: [
    //                 {
    //                     modelName: 'DeepSeek-R1',
    //                     modelCode: 'deepseek111111111111',
    //                     modelDesc: '高级推理模型满血版，可深度逻辑推演',
    //                     modelIcon:
    //                         'https://pr1-greenteacdn.lenovo.com.cn/config/202502/1738843764152_icon-deepseek.png',
    //                     status: 2
    //                 },
    //                 {
    //                     modelName: '文心一言4.5',
    //                     modelCode: 'bd-20250318180235-dgkax',
    //                     modelDesc: '百度最新一代知识增强大语言模型',
    //                     modelIcon:
    //                         'https://pr1-greenteacdn.lenovo.com.cn/config/1725875302454_icon-文心4.0.png',
    //                     status: 1
    //                 },
    //                 {
    //                     modelName: 'DeepSeek-V3',
    //                     modelCode: 'doubao/bot-20250220094346-hjkgk',
    //                     modelDesc: '智能精准，全能型AI大脑满血版',
    //                     modelIcon:
    //                         'https://pr1-greenteacdn.lenovo.com.cn/config/202502/1738843764152_icon-deepseek.png',
    //                     status: 1
    //                 },
    //                 {
    //                     modelName: '豆包Pro',
    //                     modelCode: 'doubao111111111111111',
    //                     modelDesc: '字节跳动自研LLM模型专业版',
    //                     modelIcon:
    //                         'https://pr1-greenteacdn.lenovo.com.cn/config/1725875250411_icon-豆包Pro.png',
    //                     status: 1
    //                 },
    //                 {
    //                     modelName: '通义千问Max',
    //                     modelCode: 'qianwen/qwen-max',
    //                     modelDesc: '阿里云超大规模语言模型',
    //                     modelIcon:
    //                         'https://pr1-greenteacdn.lenovo.com.cn/config/1725875285507_icon-千问Max.png',
    //                     status: 1
    //                 }
    //             ]
    //         }
    //     })
    // })
  }
  return retryPromise(asyncFn, product, 0);
}
// 获取问答运营位
export function getSuggestquestionList(data, params) {
  const { product } = data;
    return axiosGateway.get({
      url: `/cloud-browser-aigc/rest/suggestquestion/${product}/release`,
      gatewayKey: "baseURL2",
      params,
      retryConfig:{
        count: 1,
        waitTime: 200,
      }
    });
}
// 获取问题列表
export function getQuestionList(data) {
  const { product } = data;
  function asyncFn(product) {
    return axiosGateway.get({
      url: `/cloud-browser-aigc/rest/questionlibrary/v1/${product}/distribute`,
      gatewayKey: "baseURL2",
    });
  }
  return retryPromise(asyncFn, product, 0);
}

export async function getGateWayToken(data = {}, abortController) {
  let loginInfo = {};
  try {
    loginInfo = window.pcmjssdk
      ? await window.pcmjssdk.commonMethod.getLoginInfo()
      : await window.SLBSDK.nativeCall("SLGetLoginStatus");
  } catch (error) {
    console.log(error);
  }
  // 从端获取浏览器信息(UUID)
  // const SLBInfo = await window.SLBSDK.nativeCall('SLGetNativeInfo')
  // const loginInfo = ;
  // const { realm } = SLBInfo;
  loginInfo = typeof loginInfo === "object" ? loginInfo : JSON.parse(loginInfo);
  store.commit("setLoginInfo", loginInfo);
  const { token, realm } = loginInfo;
  data.token = token;
  data.realm = realm;
  return authorizeApply(data, abortController)
    .then((res) => {
      if (res.code === 10000 && res.data && res.data.accessToken) {
        const slbrowser_pc_ai_assist_authorization = `${
          res.data.tokenType ? res.data.tokenType : "bearer"
        } ${res.data.accessToken}`;
        const slbrowser_pc_ai_assist_authorization_cookie = `${SLBROWSER_PC_AI_ASSIST_AUTHORIZATION}=${slbrowser_pc_ai_assist_authorization}${
          res.data.expires
            ? ";expires=" + new Date(res.data.expires).toUTCString()
            : ""
        }`;
        document.cookie = slbrowser_pc_ai_assist_authorization_cookie;
        return slbrowser_pc_ai_assist_authorization;
      }
    })
    .catch((err) => {
      console.log("授权申请失败", err);
    });
}
